module.exports = __webpack_public_path__ + "c013ddefc4b06f9b7c8c7c7055ce44b9.svg";